import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
// Chakra imports
import {
  Image,
  Box,
  Button,
  Checkbox,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Icon,
  Input,
  InputGroup,
  InputRightElement,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
// Custom components
import { HSeparator } from 'components/separator/Separator';
import DefaultAuth from 'layouts/auth/Default';
// Assets
import illustration from 'assets/img/tablet-login-concept-illustration_114360-7963.avif';
import { FcGoogle } from 'react-icons/fc';
import { MdOutlineRemoveRedEye } from 'react-icons/md';
import { RiEyeCloseLine } from 'react-icons/ri';
import { useToast } from '@chakra-ui/react';
import axiosInstance from '../../../axiosInstance';
import baseUrl from 'Base_Url/baseUrl';
import companyLogo from '../../../assets/img/main_logo.png';
function SignIn() {
  // Chakra color mode
  const textColor = useColorModeValue('navy.700', 'white');
  const textColorSecondary = 'gray.400';
  const textColorDetails = useColorModeValue('navy.700', 'secondaryGray.600');
  const textColorBrand = useColorModeValue('brand.500', 'white');
  const brandStars = useColorModeValue('brand.500', 'brand.400');
  const googleBg = useColorModeValue('secondaryGray.300', 'whiteAlpha.200');
  const googleText = useColorModeValue('navy.700', 'white');
  const googleHover = useColorModeValue(
    { bg: 'gray.200' },
    { bg: 'whiteAlpha.300' },
  );
  const googleActive = useColorModeValue(
    { bg: 'secondaryGray.300' },
    { bg: 'whiteAlpha.200' },
  );
  const [show, setShow] = React.useState(false);
  const handleClick = () => setShow(!show);

  const [formData, setFormData] = useState({
    emailOrUsername: '',
    password: '',
  });

  const [loading, setLoading] = useState(false);

  const linkStyle = {
    textDecoration: 'underline',
    color: '#007bff',
    display: 'block',
    marginTop: '1rem',
    cursor: 'pointer',
  };

  const hoverStyle = {
    color: '#0056b3',
  };

  const navigate = useNavigate();
  const toast = useToast();

  const login = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const response = await axiosInstance.post(
        `${baseUrl}/auth/login`,
        formData,
      );
      if (response && response?.data && response?.data?.data) {
        setLoading(false);
        localStorage.setItem('role', response?.data?.data?.user?.role);
        localStorage.setItem(
          'token',
          response?.data?.data?.tokens?.access?.token,
        );
        localStorage.setItem('name', response?.data?.data?.user?.name);
        localStorage.setItem(
          'companyId',
          response?.data?.data?.user?.companyId,
        );
        if (response?.data?.data?.user?.companyName) {
          localStorage.setItem('companyName', response?.data?.data?.user?.companyName);
        }
        localStorage.setItem('username', response?.data?.data?.user?.username);
        if (response?.data?.data?.user?.email !== undefined) {
          localStorage.setItem('email', response?.data?.data?.user?.email);
        }
        if (response?.data?.data?.user?.phoneNo !== undefined) {
          localStorage.setItem('phoneNo', response?.data?.data?.user?.phoneNo);
        }
        if (response?.data?.data?.user?.createdAt !== undefined) {
          localStorage.setItem('userCreatedAt', response?.data?.data?.user?.createdAt);
        }
        if (response?.data?.data?.user?.designation !== undefined) {
          localStorage.setItem('designation', response?.data?.data?.user?.designation);
        }
        if (response?.data?.data?.user?.dashboardVersion !== undefined) {
          localStorage.setItem(
            'dashboardVersion',
            response?.data?.data?.user?.dashboardVersion,
          );
        } else {
          localStorage.setItem('dashboardVersion', 'v1');
        }
        if (response?.data?.data?.user?.district !== undefined) {
          localStorage.setItem(
            'district',
            response?.data?.data?.user?.district,
          );
        }
        toast({
          title: 'Login Successful',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        setTimeout(() => {
          navigate('/admin/dashboard');
          window.location.reload();
        }, 500);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
      
      toast({
        title: error?.response?.data?.data
          ? error?.response?.data?.data
          : error?.response?.data?.message ? error?.response?.data?.message : "An error occured!",
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  return (
    <DefaultAuth illustrationBackground={illustration} image={illustration}>
      <Flex
        maxW={{ base: '100%', md: 'max-content' }}
        w="100%"
        mx={{ base: 'auto', lg: '0px' }}
        me="auto"
        h="100%"
        alignItems="center" // Center content horizontally
        justifyContent="center"
        mb={{ base: '30px', md: '60px' }}
        px={{ base: '25px', md: '0px' }}
        mt={{ base: '20px', md: '7vh' }}
        flexDirection="column"
        style={{
          border: '0.1px solid gray',
          padding: '10px',
          boxShadow: '10px 10px 5px grey',
          borderRadius: '10px',
        }}
      >
        <Box me="auto">
          <Image
            src={companyLogo}
            alt="Company Logo"
            mb="20px"
            boxSize="100px"
            objectFit="contain"
            style={{
              width: '70%',
              margin: '0 auto',
            }}
          />
          <Heading color={textColor} fontSize="36px" mb="10px">
            Sign In
          </Heading>
          <Text
            mb="36px"
            ms="4px"
            color={textColorSecondary}
            fontWeight="400"
            fontSize="md"
          >
            Enter your email or username and password to sign in!
          </Text>
        </Box>
        <Flex
          zIndex="2"
          direction="column"
          w={{ base: '100%', md: '420px' }}
          maxW="100%"
          background="transparent"
          borderRadius="15px"
          mx={{ base: 'auto', lg: 'unset' }}
          me="auto"
          mb={{ base: '20px', md: 'auto' }}
        >
          {/* <Button
            fontSize="sm"
            me="0px"
            mb="26px"
            py="15px"
            h="50px"
            borderRadius="16px"
            bg={googleBg}
            color={googleText}
            fontWeight="500"
            _hover={googleHover}
            _active={googleActive}
            _focus={googleActive}
          >
            <Icon as={FcGoogle} w="20px" h="20px" me="10px" />
            Sign in with Google
          </Button>
          <Flex align="center" mb="25px">
            <HSeparator />
            <Text color="gray.400" mx="14px">
              or
            </Text>
            <HSeparator />
          </Flex> */}
          <FormControl as="form" onSubmit={login}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Email or Username<Text color={brandStars}>*</Text>
            </FormLabel>
            <Input
              name="emailOrUsername"
              isRequired={true}
              variant="auth"
              fontSize="sm"
              ms={{ base: '0px', md: '0px' }}
              type="text"
              value={formData.emailOrUsername}
              placeholder="Email or Username"
              mb="24px"
              fontWeight="500"
              size="lg"
              onChange={handleInputChange}
            />
            <FormLabel
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              display="flex"
            >
              Password<Text color={brandStars}>*</Text>
            </FormLabel>
            <InputGroup size="md">
              <Input
                name="password"
                isRequired={true}
                fontSize="sm"
                placeholder="Min. 8 characters"
                mb="24px"
                size="lg"
                type={show ? 'text' : 'password'}
                variant="auth"
                value={formData.password}
                onChange={handleInputChange}
              />
              <InputRightElement display="flex" alignItems="center" mt="4px">
                <Icon
                  color={textColorSecondary}
                  _hover={{ cursor: 'pointer' }}
                  as={show ? RiEyeCloseLine : MdOutlineRemoveRedEye}
                  onClick={handleClick}
                />
              </InputRightElement>
            </InputGroup>
            <Flex justifyContent="space-between" align="center" mb="24px">
              {/* <FormControl display="flex" alignItems="center">
                <Checkbox
                  id="remember-login"
                  colorScheme="brandScheme"
                  me="10px"
                />
                <FormLabel
                  htmlFor="remember-login"
                  mb="0"
                  fontWeight="normal"
                  color={textColor}
                  fontSize="sm"
                >
                  Keep me logged in
                </FormLabel>
              </FormControl> */}
              {/* <NavLink to="/auth/forgot-password">
                <Text
                  color={textColorBrand}
                  fontSize="sm"
                  w="124px"
                  fontWeight="500"
                >
                  Forgot password?
                </Text>
              </NavLink> */}
            </Flex>
            <Button
              fontSize="sm"
              variant="brand"
              fontWeight="500"
              w="100%"
              h="50"
              mb="24px"
              type="submit"
              isLoading={loading}
            >
              Sign In
            </Button>
          </FormControl>
          {/* <Flex
            flexDirection="column"
            justifyContent="center"
            alignItems="start"
            maxW="100%"
            mt="0px"
          >
            <Text color={textColorDetails} fontWeight="400" fontSize="14px">
              Not registered yet?
              <NavLink to="/auth/sign-up">
                <Text
                  color={textColorBrand}
                  as="span"
                  ms="5px"
                  fontWeight="500"
                >
                  Create an Account
                </Text>
              </NavLink>
            </Text>
          </Flex> */}
        </Flex>
      </Flex>
    </DefaultAuth>
  );
}

export default SignIn;
